<template>
  <v-app>
    <header class="header">
      <UserInfo class="user-info-container" v-if="$route.path === '/profile'"/>
      <a href="https://wiganathletic.com/">
        <img src="./assets/logo.png" height="98" width="84" class="logo" />
      </a>
      <a href="https://wiganathletic.com/" class="button button-home">Return to Home</a>
    </header>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue'
//import Vuetify from 'vuetify'
import CognitoPlugin from './cognito-plugin.js'
import VueCookie from 'vue-cookie'
import UserInfo from '@/components/UserInfo'

import Vuetify, {
  VApp, // required
  VAlert,
  VTabs,
} from 'vuetify/lib'

import { Ripple } from 'vuetify/lib/directives'

Vue.use(Vuetify, {
  components: {
    VApp,
    VAlert,
    VTabs,
  },
  directives: {
    Ripple
  }
})

Vue.use(CognitoPlugin)
Vue.use(VueCookie)
Vue.use(require('vue-moment'));

export default {
  name: 'App',
  components: {
    UserInfo
  },
  data () {
    return {
      loggedIn: false,
      referrer: null
    }
  },
  mounted () {
    console.log(window.location.href)
    
    // simple referral tracking
    if(window.location.href.includes("referred=1")){ //if the user is referred from a partner site
      localStorage.referrer = document.referrer
    }

    // JWT return tracking from trusted Domains
    if((window.location.href.includes(process.env.VUE_APP_DOMAIN ) /* || (ADD OTHER DOMAINS HERE)*/ )  && window.location.href.includes("returnUrl=")){ //if the user is referred from the StreamAMG payments site
      console.log('Trusted returnUrl set', window.location.href)
      var urlPieces = window.location.href.split("returnUrl=") 
      localStorage.returnUrl = decodeURIComponent(urlPieces[1])
    } 
    
    //Upon initial mount we check the authentication state
    console.log('Access Check', 'route change')
      if(this.$getAuthenticatedUser() != null) {
        console.log('Access Check', 'user authenticated')
        this.$getCurrentUserAttributes().subscribe((userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          console.log('Access Check', 'checking registration is complete')
          // console.log('Access Check userDate', userData)
          
          if(userData['custom:privacy_accepted'] === 'true'){
            console.log('Access Check', 'privacy accepted')
            this.loggedIn = true;
            //always force logged in users to their profile, unless they are already going there
            this.$router.push("/profile");
            
          }else{
            console.log('Access Check', 'privacy NOT previously accepted')
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }
        }, 
        (err)=> {
          console.log('Access Check', 'Unable to load user profile, session may not be present.')
          this.loggedIn = false;
        });
      
      } else {
        console.log('Access Check', 'no authenticated user present')
        this.loggedIn = false;
      }  
  },
  watch: {
    '$route' (to) {
      //Upon each route change we check the authentication state

      console.log('Access Check', 'route change')
      if(this.$getAuthenticatedUser() != null) {
        console.log('Access Check', 'user authenticated')
        this.$getCurrentUserAttributes().subscribe((userData) => {
          //check if the user has completed their registration (mostly this will be Social Media Registrations, post linking of their account)
          console.log('Access Check', 'checking registration is complete')
          // console.log('Access Check userDate', userData)
          
          if(userData['custom:privacy_accepted'] === 'true'){
            console.log('Access Check', 'privacy accepted')
            // tell the app that we've finished loading
            if(to.path!='/profile'){
              this.loggedIn = true;
              //always force logged in users to their profile, unless they are already going there
              this.$router.push("/profile");
            }
          }else{
            console.log('Access Check', 'privacy NOT previously accepted')
            this.loggedIn = false;
            this.$router.push("/complete-registration");
          }
        }, 
        (err)=> {
          console.log('Access Check', 'Unable to load user profile, session may not be present.')
          this.loggedIn = false;
        });
      
      } else {
        console.log('Access Check', 'no authenticated user present')
        this.loggedIn = false;
      }
    }
  }
}
</script>

<style lang="scss">
  @import '/css/global.scss';
</style>

<style lang="scss" scoped>
  .header {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    padding: 20px 20px 0;
    margin: 0 0 35px;
  }

  .user-info-container {
    margin: 20px 0 0;
  }

  .button-home {
    display: block;
  }

  @media screen and (min-width: 700px) {
    .header {
      flex-direction: row;
      justify-content: space-between;
      padding: 48px 100px 48px;
    }

    .user-info-container {
      top: 43px;
      left: 20px;
      margin: 0;
    }
    .logo{
      margin-left: -90px;
    }

    .button-home {
      display: block;
    }
  }

  @media screen and (min-width: 1200px) {
    .header {
      padding: 48px 300px 48px;
    }
  }
</style>
